// extracted by mini-css-extract-plugin
export default {"root":"InfoModalColumn_root__dZH3G","li":"InfoModalColumn_li__+Shbr","label":"InfoModalColumn_label__6eJEG","value":"InfoModalColumn_value__I9r1H"};